"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var SMTP_TOKENS_URI = 'email/v1/smtpapi/tokens';

var SmtpTokensAPI =
/*#__PURE__*/
function () {
  function SmtpTokensAPI() {
    (0, _classCallCheck2.default)(this, SmtpTokensAPI);
  }

  (0, _createClass2.default)(SmtpTokensAPI, null, [{
    key: "getSmtpTokens",
    value: function getSmtpTokens() {
      return _apiClient.default.get(SMTP_TOKENS_URI);
    }
  }, {
    key: "createSmtpToken",
    value: function createSmtpToken(smtpToken) {
      return _apiClient.default.post(SMTP_TOKENS_URI, {
        data: smtpToken
      });
    }
  }, {
    key: "resetSmtpTokenPassword",
    value: function resetSmtpTokenPassword(smtpToken) {
      return _apiClient.default.post(SMTP_TOKENS_URI + "/" + smtpToken.userName + "/password-reset");
    }
  }, {
    key: "deleteSmtpToken",
    value: function deleteSmtpToken(smtpToken) {
      return _apiClient.default.delete(SMTP_TOKENS_URI + "/" + smtpToken.userName);
    }
  }]);
  return SmtpTokensAPI;
}();

exports.default = SmtpTokensAPI;
module.exports = exports.default;